import { useState } from "react";
import { Wrapper } from "@googlemaps/react-wrapper";
import GoogleMap from "google-map-react";

import { Panel } from "../components/Panel";

import "./LocationsPanel.scss";
import { bemName } from "../util/bemName";
import MarkerIcon from "../res/logos/solarcloud/logo-icon.svg";
import { ErrorBoundary } from "react-error-boundary";
import { useEnvironmentContext } from "@/contexts/EnvironmentContext";
import H1 from "@/components/ui/H1";

const Marker = ({ blockName }: any) => {
  return (
    <div className={bemName(blockName, "marker")}>
      <MarkerIcon />
    </div>
  );
};

const componentName = "LocationsPanel";

interface Props {
  blockName?: string;
}

export const LocationsPanel: React.FunctionComponent<Props> = ({
  blockName,
}) => {
  const [center] = useState({ lat: -32.614457, lng: 149.573329 });
  const [zoom] = useState(11);
  const environment = useEnvironmentContext();

  const block = blockName || componentName;

  return (
    <div className="bg-brand-neutral-900 px-8 py-6  md:px-16 md:py-12 rounded-3xl">
      <H1 className="mb-4 md:mb-8">Locations</H1>
      <div className="w-full" style={{ height: 600 }}>
        {environment && (
          <ErrorBoundary
            fallback={
              <div className={bemName(block, "fallback")}>
                Sorry, there was a problems loading the location map. Please try
                again at a later time.
              </div>
            }
          >
            <Wrapper apiKey={environment.google.apiKey}>
              <GoogleMap
                bootstrapURLKeys={{ key: environment.google.apiKey }}
                defaultCenter={center}
                defaultZoom={zoom}
                yesIWantToUseGoogleMapApiInternals={true}
                onGoogleApiLoaded={({ map, maps }) => {
                  try {
                    const bounds = new maps.LatLngBounds();
                    bounds.extend(new maps.LatLng(-32.614457, 149.573329));
                    bounds.extend(new maps.LatLng(-37.8136, 144.9631));
                    map.fitBounds(bounds);
                  } catch (e) {
                  }
                }}
              >
                <Marker
                  blockName={block}
                  lat={-32.614457}
                  lng={149.573329}
                  label={"Mudgee"}
                  style={{ color: "black" }}
                />
                <Marker
                  blockName={block}
                  lat={-37.8136}
                  lng={144.9631}
                  label={"Melbourne"}
                  style={{ color: "black" }}
                />
              </GoogleMap>
            </Wrapper>
          </ErrorBoundary>
        )}
      </div>
    </div>
  );
};

export default LocationsPanel;
